<script setup lang="ts">
import ScreenActionWidget from "@/components/EditView/widgets/ScreenActionWidget.vue";
import {ICellRendererParams} from "ag-grid-community";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import GUIActionPlaceholder = namaTypes.GUIActionPlaceholder;

const props = defineProps<{
  params: ICellRendererParams & {
    actions: GUIActionPlaceholder[],
    presenter: () => WidgetsPresenter
  }
}>();

const actions = props.params.actions
const presenter = props.params.presenter();
</script>

<template>
  <div class="tw-w-full tw-flex tw-items-center tw-py-1 tw-gap-1.5 tw-h-full tw-max-h-full">
    <template v-for="action in actions">
      <ScreenActionWidget :presenter="presenter" :action="action" :params="params"/>
    </template>
  </div>
</template>
